<div class="zoom-modal-container">
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <button mat-icon-button (click)="close()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-content">
    <div [chart]="zoomedChart" class="zoomed-highcharts-box"></div>
  </div>
</div>
